export default __webpack_public_path__ + "static/media/Click.42550785.mp3";